import {
  LocalStorageStickyBucketService,
  GrowthBook as NativeGrowthBook,
  TrackingCallback,
} from '@growthbook/growthbook-react';

export const GROWTH_BOOK_API_HOST =
  process.env.GROWTH_BOOK_API_HOST || 'https://growthbook.justdone.ai';

class GrowthBook {
  private instance: NativeGrowthBook | null = null;

  private trackingCallbacks: TrackingCallback[] = [];

  getInstance(): NativeGrowthBook {
    if (!this.instance) {
      this.instance = new NativeGrowthBook({
        apiHost: GROWTH_BOOK_API_HOST,
        clientKey: process.env.GROWTH_BOOK_API_KEY,
        enableDevMode: true,
        trackingCallback: (experiment, result): void => {
          this.trackingCallbacks.forEach((cb) => cb(experiment, result));
        },
        stickyBucketService: new LocalStorageStickyBucketService(),
      });
    }

    return this.instance;
  }

  configureTracking(callbacks: TrackingCallback[]): void {
    this.trackingCallbacks = [...callbacks];
  }

  async init(attributes: Record<string, any>): Promise<void> {
    const instance = this.getInstance();

    await instance.setAttributes(attributes);

    if (instance.getClientKey()) {
      await instance.init();
    }
  }
}

const growthBook = new GrowthBook();

export { growthBook };
